import React from "react";
import CommonHeader from "../../../../components/CommonHeader";
import { Col } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import LabelContentComponent from "../LabelContentComponent";
import { US_STATES } from "../../../../consts/usStates";
import { IDonorDTO } from "../../../../../types/IDonorDTO";
import { Section } from "../../../../components/Section/Section";

interface DemographicInformationProps {
   loading: boolean;
   isMobile: boolean;
   profileData: IDonorDTO | null;
}
const DemographicInformation: React.FC<DemographicInformationProps> = ({
   loading,
   isMobile,
   profileData,
}) => {
   return (
      <Section className="personal-card-css">
         <CommonHeader title="DEMOGRAPHIC INFORMATION" />
         <div className="personal-content-css">
            <Row className="personal-section-css">
               <Col>
                  <LabelContentComponent
                     loading={loading}
                     label={"Street Address(Line 1)"}
                     value={profileData ? profileData.address : ""}
                  />
               </Col>
               <Col>
                  <LabelContentComponent
                     loading={loading}
                     label={"Street Address(Line 2)"}
                     value={profileData?.address2 || ""}
                  />
               </Col>
               <Col>
                  <LabelContentComponent
                     loading={loading}
                     label={"City"}
                     value={profileData ? profileData.city : ""}
                  />
               </Col>
            </Row>
            <hr className="line-css" />
            <Row className="personal-section-css">
               <Col>
                  <LabelContentComponent
                     loading={loading}
                     label={"State"}
                     value={profileData ?
                     US_STATES.find(
                           stateVal =>
                              stateVal.abbreviation === profileData.state,
                        )?.name || profileData.state : ""
                     }
                  />
               </Col>
               <Col>
                  <LabelContentComponent
                     loading={loading}
                     label={"Zip Code"}
                     value={profileData ? profileData.zipCode : ""}
                  />
               </Col>
               <Col></Col>
            </Row>
            <hr className="line-css" />
            <Row className="personal-section-css">
               <Col>
                  <LabelContentComponent
                     loading={loading}
                     label={"Home Phone"}
                     value={profileData ? profileData.homePhone : ""}
                  />
               </Col>
               <Col>
                  <LabelContentComponent
                     loading={loading}
                     label={"Cell Phone"}
                     value={profileData ? profileData.cellPhone : ""}
                  />
               </Col>
               <Col>
                  <LabelContentComponent
                     loading={loading}
                     label={"Business Phone"}
                     value={profileData ? profileData.businessPhone : ""}
                  />
               </Col>
            </Row>
            <hr className="line-css" />
            <Row className="personal-section-css">
               <Col>
                  <LabelContentComponent
                     loading={loading}
                     label={"Home Email"}
                     value={profileData ? profileData.email : ""}
                  />
               </Col>
               <Col>
                  <LabelContentComponent
                     loading={loading}
                     label={"Work Email"}
                     value={profileData ? profileData.workEmail : ""}
                  />
               </Col>
               <Col></Col>
            </Row>
         </div>
      </Section>
   );
};

export default DemographicInformation;
